export default __webpack_public_path__ + "static/media/subject.dcbe97b4.png";